
export const SET_MSG = 'DEPEDENTE_MSG';
export const SET_EDITAR = 'DEPEDENTE_EDITAR';
export const SET_LISTA = 'LISTA_EDITAR';
export const SET_CATEGORIAS = 'LISTA_CATEGORIAS';
export const SET_PERFIL = 'LISTA_PERFIL';
export const SET_EVENTO = 'LISTA_EVENTO';